// angular
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImageModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
// material
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ButtonsModule } from '@app/infrastructure/buttons/buttons.module';
import { CounterModule } from '@app/infrastructure/directives/counter/counter.module';
import { CircleInfoTooltipModule } from '@app/infrastructure/tooltips/circle-info-tooltip/circle-info-tooltip.module';
import { CommitmentListModule } from '@modules/potential-save-modal/commitment-list/commitment-list.module';
import { SharedModule } from '@modules/shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
// components
import { RefreshPotentialSavingsComponent } from './refresh-potential-savings/refresh-potential-savings.component';
import { ApplyPotentialSavingsComponent } from './apply-potential-savings/apply-potential-savings.component';
import { PotentialSaveModalComponent } from './potential-save-modal.component';
import { LinuxUncoveredComponent } from './linux-uncovered/linux-uncovered.component';
import { SavingsBreakdownComponent } from './savings-breakdown/savings-breakdown.component';
import { TotalSavingsComponent } from './total-savings/total-savings.component';
import { SpAllocationComponent } from './sp-allocation/sp-allocation.component';
import { RenewalOverTimeComponent } from './renewal-over-time/renewal-over-time.component';
import { SwitchToEdpModeComponent } from '@modules/potential-save-modal/switch-to-edp-mode/switch-to-edp-mode.component';
// modules
import { SpinnerModule } from '@app/shared/spinner/spinner.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TableModule } from '@app/infrastructure/data-list/table/table.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { EmptyValueModule } from '@app/infrastructure/pipes/empty-value/empty-value.module';
import { PotentialSavingErrorType } from './potential-savings-views.enum';
import { PotentialSaveErrorsModalComponent } from './potential-save-errors-modal/potential-save-errors-modal.component';
import { CoveragePlanComponent } from './coverage-plan/coverage-plan.component';
import { SavingsGraphComponent } from './savings-graph/savings-graph.component';
import { StateSwitcherModule } from '@app/infrastructure/state-switcher/state-switcher.module';

@NgModule({
	imports: [
		CommonModule,
		SpinnerModule,
		PipesModule,
		MatSlideToggleModule,
		MatDialogModule,
		TableModule,
		NgxEchartsModule,
		TooltipModule,
		ButtonsModule,
		CounterModule,
		EmptyValueModule,
		CommitmentListModule,
		CircleInfoTooltipModule,
		NgOptimizedImageModule,
		MatCheckboxModule,
		ReactiveFormsModule,
		SharedModule,
		StateSwitcherModule,
	],
	declarations: [
		RefreshPotentialSavingsComponent,
		SwitchToEdpModeComponent,
		SavingsBreakdownComponent,
		ApplyPotentialSavingsComponent,
		TotalSavingsComponent,
		SpAllocationComponent,
		RenewalOverTimeComponent,
		LinuxUncoveredComponent,
		PotentialSaveModalComponent,
		PotentialSaveErrorsModalComponent,
		CoveragePlanComponent,
		SavingsGraphComponent,
	],
	providers: [],
	exports: [
		RefreshPotentialSavingsComponent,
		SwitchToEdpModeComponent,
		SavingsBreakdownComponent,
		ApplyPotentialSavingsComponent,
		TotalSavingsComponent,
		SpAllocationComponent,
		RenewalOverTimeComponent,
		LinuxUncoveredComponent,
		PotentialSaveModalComponent,
		PotentialSaveErrorsModalComponent,
	],
})
export class PotentialSavingModalModule {}
